import React from 'react';
import TrendIndicator from './TrendIndicator';

const SmallMetricCard: React.FC<{
    value: string | number;
    label: string;
    Icon: React.ElementType;
    iconColor: string;
    trend: string;
    trendType: 'up' | 'down';
    className?: string;
}> = ({ value, label, Icon, iconColor, trend, trendType, className = "" }) => {

    // Fix icon background: convert text-blue-500 → bg-blue-500/10
    const bgColor = iconColor.replace("text-", "bg-") + "/10";

    return (
        <div
            className={`bg-white p-4 rounded-lg shadow relative flex flex-col justify-center  h-[130px] ${className}`}
        >
            <div className="flex items-start space-x-4">
                <div className={`p-2 rounded-full m-0 flex justify-center items-center ${bgColor}`}>
                    <Icon className={`text-2xl ${iconColor}`} />
                </div>

                <div>
                    <div className="text-2xl font-bold text-gray-800">{value}</div>
                    <div className="text-xs text-gray-500">{label}</div>
                </div>
            </div>

            <div className="absolute bottom-4 right-4">
                <TrendIndicator trend={trend} trendType={trendType} />
            </div>
        </div>
    );
};

export default SmallMetricCard;
